export default __webpack_public_path__ + "static/media/single_web-sm@1x.d309f6b0.webp";